import { InverseTriangle } from './triangle';
import { CustomTickComponentProps } from './custom-x-tick';

const labelHeight = 14;
const tickHeight = 5;
const tickWidth = 10;

export interface CustomTickProps {
  isLegacy: boolean;
  height: number;
}

export const CustomYTick: React.FC<CustomTickProps> = ({ isLegacy, height, ...props }) => {
  const tickProps = props as CustomTickComponentProps;

  if (tickProps.index % 2 !== 0 || isLegacy) return null;
  return (
    <InverseTriangle
      x={tickProps.x1 - 5}
      y={height - labelHeight - tickHeight}
      height={`${tickHeight}px`}
      width={`${tickWidth}px`}
    />
  );
};
